export default __webpack_public_path__ + "static/Youth-Planning-ceca1a7dffa93e9f5701826e7ad22c5a.svg";